export default "__VITE_ASSET__BKaaRitJ__"